import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { Dialog } from 'primereact/dialog';
import Toast from '../../Shared/Toast/Toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import TemplateValues from './TemplateValues';
import { MultiSelect } from 'primereact/multiselect';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Dropdown } from 'primereact/dropdown';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const AddEditExamTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState('');
    const [visible, setVisible] = useState(false);
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
    const [examTemplateValues, setExamTemplateValues] = useState([]);
    const [classList, setClassList] = useState([]);
    const [className, setClassName] = useState([]);
    const [classNameErr, setClassNameErr] = useState([]);
    const [classNameErrText, setClassNameErrText] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const submitButtonRef = useRef(null);
    const titleNameRef = useRef(null);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, props?.masterData?.FinancialYear || props?.financialYearId);
        if (props?.configId) {
            setTitleName(props?.masterData?.TemplateName);
            setSelectedYear(props?.masterData?.FinancialYear);
            setExamTemplateValues(props?.masterData?.TemplateValues);
            setClassName(props?.masterData?.ClassDetailId ? props?.masterData?.ClassDetailId.split(',') : []);
        } else {
            setSelectedYear(props?.financialYearId);
        }
    }, []);

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                            ...x,
                            value: x?._id,
                            label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                        }))
                    );
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        if (!className.length) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Select atleast one class");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
    }

    const onValueCancel = () => {
        setVisible(false);
        setEditingIndex(null);
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                const selectedClasses = className || [];

                const classDetailIds = [];
                const classNos = new Set();
                const mediumIds = [];
                const boardIds = [];

                selectedClasses?.forEach((classDetailId) => {
                    const classData = classList?.find(x => x?.value === classDetailId);

                    if (classData) {
                        classDetailIds.push(classData.value);
                        if (classData.ClassId) classNos.add(classData.ClassId);
                        mediumIds.push(classData.Medium);
                        boardIds.push(classData.BoardName);
                    }
                });
                const filteredData = examTemplateValues?.map(x => {
                    const newObj = { ...x };

                    if (typeof newObj._id === "string" && newObj?._id?.startsWith("temp_")) {
                        delete newObj._id;
                    }

                    // Clean extra fields not in schema
                    delete newObj.BestOfValueName;
                    delete newObj.TotalValueName;
                    delete newObj.TermName;
                    delete newObj.Weightage;

                    // ReExamType must be string, not array
                    if (Array.isArray(newObj.ReExamType)) {
                        newObj.ReExamType = newObj.ReExamType.length > 0 ? newObj.ReExamType.join(',') : '';
                    }

                    return newObj;
                });

                let data = {
                    id: props?.configId,
                    TemplateName: titleName,
                    FinancialYear: selectedYear,
                    ClassId: [...classNos].join(','),
                    ClassDetailId: classDetailIds.join(','),
                    MediumId: mediumIds.join(','),
                    BoardId: boardIds.join(','),
                    TemplateValues: filteredData,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateResultTemplate, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const valueBodyTemplate = (rowData, { rowIndex }) => {
        return rowData?.ExamType === 'Best Of' ? rowData?.BestOfValueName || '-' : rowData?.TotalValueName || '-';
    };

    const reExamBodyTemplate = (rowData) => {
        return rowData?.ExamType === 'Re-Exam' ? rowData?.ReExamTypeName || '-' : '-';
    };

    const weightageBodyTemplate = (rowData) => {
        return rowData?.Weightage || '-';
    };

    const isOverBodyTemplate = (rowData) => {
        return rowData?.ExamType === 'Total' ? rowData?.IsOverAllAllow ? 'Yes' : 'No' : '-';
    };

    const isGradeBodyTemplate = (rowData) => {
        return (rowData?.ExamType === 'Total' || rowData?.ExamType === 'Individual') ? rowData?.IsGradeAllow ? 'Yes' : 'No' : '-';
    };

    const isPractiseTestBodyTemplate = (rowData) => {
        return rowData?.ExamType === 'Individual' ? rowData?.IsPractiseTest ? 'Yes' : 'No' : '-';
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-d-flex p-jc-start">
            <Button
                icon="pi pi-pencil"
                className="e-sction-btn p-m-0 p-m-2"
                onClick={() => openDialogForEdit(rowIndex)}
            />
            <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2"
                onClick={() => removeTemplateValue(rowIndex)}
            />
        </div>
    );

    const openDialogForEdit = (index) => {
        setEditingIndex(index);
        setVisible(true);
    };

    const removeTemplateValue = (index) => {
        setExamTemplateValues(prevValues => prevValues.filter((_, i) => i !== index));
    };

    const generateTempId = () => {
        return `temp_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
    };

    const handleSaveTemplateValue = (value) => {
        setExamTemplateValues(prevValues => {
            let updatedValues;

            const valueWithId = {
                ...value,
                _id: value?._id ? value._id : generateTempId(),
            };

            if (editingIndex !== null) {
                updatedValues = [...prevValues];

                updatedValues[editingIndex] = {
                    ...valueWithId,
                    SrNo: prevValues[editingIndex].SrNo
                };

            } else {
                updatedValues = [
                    ...prevValues,
                    {
                        ...valueWithId,
                        SrNo: prevValues.length + 1
                    }
                ];
            }

            return updatedValues;
        });

        setEditingIndex(null);
        setVisible(false);
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        const items = Array.from(examTemplateValues);
        const [movedItem] = items.splice(sourceIndex, 1);
        items.splice(destinationIndex, 0, movedItem);

        const updated = items.map((item, index) => ({
            ...item,
            SrNo: index + 1,
        }));

        setExamTemplateValues(updated);
    };

    const dragHandleTemplate = (rowData, options) => (
        <Draggable draggableId={rowData?._id?.toString()} index={options.rowIndex}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                        cursor: "grab",
                        fontSize: "18px",
                        textAlign: "center",
                        background: snapshot.isDragging ? "#e3f2fd" : "transparent",
                        ...provided.draggableProps.style,
                    }}
                >
                    ☰
                </div>
            )}
        </Draggable>
    );

    return (
        <div className="e-exam-master-table">
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className='p-grid'>
                    <div className="p-col-12 p-md-4 p-pt-2 custom-inputs">
                        <label htmlFor="titleName">Template Name<span style={{ color: "red" }}>*</span></label>
                        <FloatLabel>
                            <InputText
                                ref={titleNameRef}
                                className='p-w-100 input-height'
                                id="titleName"
                                value={titleName}
                                maxLength={100}
                                onChange={(e) => setTitleName(e.target.value)}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {titleNameErr ? titleNameErrText : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-4 p-pt-2">
                        <label htmlFor="className">Class<span style={{ color: "red" }}>*</span></label>
                        <div className="p-d-flex p-ai-center custom-inputs">
                            <MultiSelect
                                id="className"
                                value={className}
                                options={classList}
                                onChange={(e) => setClassName(e.value)}
                                placeholder="Select Class"
                                display="chip"
                                className='p-w-100'
                                style={{ height: '42px' }}
                                filter
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                            <div className='p-ml-2'>
                                <Button icon='pi pi-plus' className="e-h-btn p-px-4" onClick={() => setVisible(true)} />
                            </div>
                            <span className="error-msg" style={{ color: 'red' }}>
                                {classNameErr ? classNameErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="selectedYear">Academic Years</label>
                            <Dropdown
                                id="selectedYear"
                                value={selectedYear}
                                options={props?.academicYearList}
                                onChange={(e) => setSelectedYear(e.value)}
                                placeholder="Select Academic Year"
                                display="chip"
                                className='p-w-100'
                                filter
                                optionLabel="label"
                                optionValue="_id"
                                showClear
                            />
                        </div>
                    </div>
                    <div className='p-w-100 e-grade-master-table'>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="students" direction="vertical">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided?.droppableProps}>
                                        <DataTable
                                            value={examTemplateValues}
                                            dataKey="_id"
                                            className="p-datatable-sm"
                                        >
                                            <Column
                                                header="#"
                                                body={dragHandleTemplate}
                                                style={{ width: "3rem" }}
                                            />
                                            <Column
                                                header="Sr No"
                                                body={(rowData, options) => options.rowIndex + 1}
                                            />
                                            <Column header="Exam Type" field="ExamType" />
                                            <Column header="Name" field="Name" />
                                            <Column header="Short Name" field="ShortName" />
                                            <Column header="Marks" field="Marks" />
                                            <Column header="Min Marks" field="MinMarks" />
                                            <Column header="Over All" body={isOverBodyTemplate} />
                                            <Column header="Grade Apply" body={isGradeBodyTemplate} />
                                            <Column header="Term" field="TermName" />
                                            <Column header="Value" body={valueBodyTemplate} />
                                            <Column header="Re-Exam Type" body={reExamBodyTemplate} />
                                            <Column header="Practise Test" body={isPractiseTestBodyTemplate} />
                                            <Column header="Weightage" body={weightageBodyTemplate} />
                                            <Column header="Actions" body={actionsBodyTemplate} />
                                        </DataTable>
                                        {provided?.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
            <Dialog
                header={"Template Value"}
                visible={visible}
                onHide={() => onValueCancel()}
                draggable={false}
                position="center"
                style={{ width: '62vw', height: '82vh' }}
            >
                <TemplateValues onCancel={onValueCancel} onSave={handleSaveTemplateValue}
                    editData={editingIndex !== null ? examTemplateValues[editingIndex] : null} bestOfList={examTemplateValues.length ? examTemplateValues.filter(x => x?.ExamType === 'Individual') : []} totalOfList={examTemplateValues.length ? examTemplateValues.filter(x => x?.ExamType === 'Total') : []} allList={examTemplateValues} totalBestOfData={examTemplateValues.length ? examTemplateValues.filter(x => x?.ExamType === 'Best Of') : []} />
            </Dialog>
        </div >
    );
};

export default AddEditExamTemplate;
